export default __webpack_public_path__ + "static/img5-15992a63d2488979108b366a07f36071.png";